import { render, staticRenderFns } from "./Convencion2025Merchandising.vue?vue&type=template&id=120f6401&"
import script from "./Convencion2025Merchandising.vue?vue&type=script&lang=js&"
export * from "./Convencion2025Merchandising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports